import Vue from '../vue/common/vue-common';
import HorizontalScrollbar from '../vue/components/common/container/HorizontalScrollbar.vue';
import { getSimpleVueHorizontalScroll } from '../vue/horizontal-scroll';
import cr$ from '../../../submodules/src/script/crquery';
import OurStores from '../vue/components/nossas-lojas/OurStores.vue';

cr$.ready(function () {
    requestIdleCallback(() => new Vue(OurStores));

    const highlightsEl = cr$.byId('nossas-lojas');
    if (highlightsEl.exists()) {
        requestIdleCallback(() => {
            new Vue({
                template: `<HorizontalScrolllbar />`,
                components: { HorizontalScrollbar },
            });
        });
    }

    const storeImagesEl = cr$.byId('our-stores-carousel');
    if (highlightsEl.exists()) {
        requestIdleCallback(() => getSimpleVueHorizontalScroll(storeImagesEl.raw));
    }

    const storeImagesEl2 = cr$.byId('our-stores-carousel-2');
    if (highlightsEl.exists()) {
        requestIdleCallback(() => getSimpleVueHorizontalScroll(storeImagesEl2.raw));
    }
});
